export default __webpack_public_path__ + "static/28-0e40807de707a35f352bcdb2d48c687e.png";